'use client';

import { APP_PLATFORM } from '@/utils/constants';
import { PlatformBridgeBase } from './base';

export class PlatformBridgeIos extends PlatformBridgeBase {
    platform = APP_PLATFORM.Ios;
    bridgeCommands = ['closeWebView'];

    constructor() {
        super();
        this.bridge = window.webkit?.messageHandlers?.bridge ?? null;
    }

    public isCompatible = () => !!this.bridge;

    protected closeWebView() {
        // corewebview method
        this.bridge?.postMessage({
            topic: 'internal-navigation',
            method: 'navigate',
            payload: JSON.stringify({ page: 'close' })
        });
    }
}
